import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  selector: 'email-company-deleted-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './company-deleted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyDeletedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CompanyDeletedTemplateData>;
}

export type CompanyDeletedTemplateData = {
  title: string;
  p1_html: string;
  p2: string;
  footer: string;
  footer_link_text: string;
  support_email: string;
};

export const CompanyDeletedTemplateMocks: CompanyDeletedTemplateData[] = [
  {
    title: 'Hi Jane 👋',
    p1_html: 'The <b>ACME</b> company account has been <b>successfully deleted</b>.',
    p2: 'All company data has been permanently deleted and the company will no longer appear in your company dashboard.',
    footer: "You've received this email because you're an admin at ACME company.",
    footer_link_text: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
